<template>
  <div>
    <a-menu
      v-model="tenantMenu"
      bottom
      left
      offset-y
      :menu-props="{ bottom: true, offsetY: true }"
      v-if="!timerPage"
      nudge-bottom="2"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom :disabled="hideTooltip">
          <template v-slot:activator="{ on: tooltip }">
            <a-btn
              class="mr-5"
              text
              v-bind="attrs"
              v-on="{ ...tooltip, ...menu }"
            >
              <v-icon class="mr-2" size="20" color="neutralGray"
                >mdi-domain</v-icon
              >
              {{ tenantName }}
              <v-icon v-if="tenantMenu" class="ml-3" color="neutralGray"
                >mdi-chevron-up</v-icon
              >
              <v-icon v-else class="ml-3" color="neutralGray"
                >mdi-chevron-down</v-icon
              >
            </a-btn>
          </template>
          <span>{{ $t("tpSwitchTenant") }}</span>
        </v-tooltip>
      </template>
      <v-card flat>
        <div class="pt-2" style="padding: 0">
          <div class="px-4 pb-2">
            <v-text-field
              class="Neutral search-input"
              color="neutralGray"
              v-model.trim="searchCompanyName"
              dense
              filled
              single-line
              hide-details
              :label="$t('lblCompanyName')"
              @input="onSearch"
            >
              <template v-slot:prepend-inner>
                <v-icon size="20" class="mr-2" color="neutralGray"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </div>
          <v-card-text class="pa-0" style="max-height: 250px; overflow: auto">
            <v-treeview
              v-model="selectedTenant"
              :active.sync="selectedTenant"
              dense
              hoverable
              activatable
              :items="processedTreeItems"
              item-key="id"
              item-text="name"
              item-children="tenants"
              :return-object="false"
              selection-type="independent"
              class="menu-list-item"
              :search="searchCompanyName"
              :open.sync="openNodeIds"
              :open-all="true"
            >
              <template v-slot:prepend="{ item }">
                <v-icon v-if="item.isGroup" size="20" color="neutralGray">
                  mdi-folder
                </v-icon>
                <v-icon v-else size="20" color="neutralGray">mdi-domain</v-icon>
              </template>
              <template v-slot:label="{ item }">
                <div
                  :style="{ cursor: 'pointer' }"
                  @click.stop="!item.disabled && onTenantChange(item)"
                >
                  {{ item.name }}
                </div>
              </template>
            </v-treeview>
          </v-card-text>

          <div v-if="!processedTreeItems.length" class="text-center py-2">
            {{ $t("noData") }}
          </div>

          <div class="d-flex justify-center py-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="3"
              class="pa-1"
            />
          </div>

          <div class="d-flex justify-end px-4 pb-2">
            <a-btn color="primary" small text @click="openChangeOrderDialog">
              <span>{{ $t("lblChangeOrder") }}</span>
            </a-btn>
          </div>
        </div>
      </v-card>

      <!-- <v-card flat>
        <v-list dense class="pt-2" style="padding: 0">
          <v-list-item>
            <v-text-field
              class="Neutral search-input"
              color="neutralGray"
              v-model.trim="searchCompanyName"
              dense
              filled
              single-line
              hide-details
              :label="$t('lblCompanyName')"
              @input="onSearch"
            >
              <template v-slot:prepend-inner>
                <v-icon size="20" class="mr-2" color="neutralGray"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </v-list-item>
          <v-card-text class="pa-0" style="max-height: 250px; overflow: auto">
            <v-treeview
              v-model="selectedTenant"
              :active.sync="selectedTenant"
              dense
              hoverable
              activatable
              :items="processedTreeItems"
              item-key="id"
              item-text="name"
              item-children="tenants"
              :return-object="false"
              selection-type="independent"
              class="menu-list-item"
              :search="searchCompanyName"
              :open.sync="openNodeIds"
            >
              <template v-slot:prepend="{ item }">
                <v-icon v-if="item.isGroup" size="20" color="neutralGray">
                  mdi-folder</v-icon
                >
                <v-icon v-else size="20" color="neutralGray">mdi-domain</v-icon>
              </template>
              <template v-slot:label="{ item }">
                <div
                  :style="{ cursor: 'pointer' }"
                  @click.stop="!item.disabled && onTenantChange(item)"
                >
                  {{ item.name }}
                </div>
              </template>
            </v-treeview>
          </v-card-text>
          <v-list-item
            v-if="!processedTreeItems.length"
            class="m-auto d-flex justify-center"
          >
            {{ $t("noData") }}
          </v-list-item>
          <v-list-item class="m-auto d-flex justify-center">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="3"
              class="pa-1"
            ></v-pagination>
          </v-list-item>
          <v-list-item>
            <v-spacer></v-spacer>
            <a-btn
              class="mr-2 mb-2"
              color="primary"
              small
              text
              @click="openChangeOrderDialog"
            >
              <span>{{ $t("lblChangeOrder") }}</span>
            </a-btn>
          </v-list-item>
        </v-list>
      </v-card> -->
    </a-menu>
    <tenant-list-organizer
      v-if="showTenantOrgDialog"
      v-model="showTenantOrgDialog"
    ></tenant-list-organizer>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
import TenantListOrganizer from "../tenant/TenantListOrganizer.vue";
import { cloneDeep } from "lodash";
import { transformTenantGroupData } from "@/utils/util";
import userAuthService from "@/api/userAuthorizationService";

export default {
  components: { ABtn, AMenu, TenantListOrganizer },
  name: "TenantSelector",
  data() {
    return {
      isOpenAll: false,
      tenantName: "",
      selectedTenant: [],
      tenantMenu: false,
      hideTooltip: false,
      tenantItems: [],
      searchCompanyName: "",
      items: [], // List of all items
      page: 1,
      itemsPerPage: 5,
      showTenantOrgDialog: false,
      selectedGroupTenant: [],
      refSelectedTenant: [],
      openNodeIds: [],
      refTenantList: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$auth.user.tenant_grouping_list) {
            const tenantList =
              this.$auth.user.tenant_grouping_list.tenants || [];
            this.tenantItems = transformTenantGroupData(
              this.$auth.user.tenant_grouping_list
            );
            this.refTenantList = cloneDeep(this.tenantItems);

            const currentTenant = tenantList.find(
              (t) => t.id === sessionStorage.getItem("tenantId")
            );
            this.selectedTenant = [];
            this.selectedTenant.push(currentTenant.id);
            this.refSelectedTenant = cloneDeep(this.selectedTenant);
            this.tenantName = currentTenant ? currentTenant.name : "";
          }
        }
      },
    },
    switchTenantId(value) {
      const tenantList = this.$auth.user.tenant_grouping_list.tenants || [];
      const currentTenant = tenantList.find((t) => t.id === value);
      this.selectedTenant = [];
      this.selectedTenant.push(currentTenant.id);
      this.refSelectedTenant = cloneDeep(this.selectedTenant);
      this.tenantName = currentTenant ? currentTenant.name : "";
    },
    tenantMenu(value) {
      if (value) {
        this.hideTooltip = true;
      } else {
        this.hideTooltip = false;
      }
    },
    processedTreeItems: {
      immediate: true,
      handler(newItems, oldItems) {
        if (this.$auth.user.tenant_grouping_list) {
          const tenantList = this.$auth.user.tenant_grouping_list.tenants || [];
          const currentTenant = tenantList.find(
            (t) => t.id === sessionStorage.getItem("tenantId")
          );
          this.selectedTenant = [];
          this.selectedTenant.push(currentTenant.id);
        }
      },
    },
    searchCompanyName(val) {
      if (val && val.trim() !== "") {
        this.openNodeIds = this.getAllGroupNodeIds(this.processedTreeItems);
      } else {
        this.openNodeIds = [];
      }
    },
    tenantGroupingList(value) {
      if (value) {
        this.tenantItems = transformTenantGroupData(value);
        this.refTenantList = cloneDeep(this.tenantItems);
      }
    },
  },
  computed: {
    ...mapState({
      switchTenantId: (state) => state.switchTenantId,
      tenantGroupingList: (state) => state.admin.tenantGroupingList,
    }),
    timerPage() {
      return (
        this.$route.path.startsWith("/meetingTimer/") ||
        this.$route.path.startsWith("/usermanual") ||
        this.$route.path.startsWith("/licensepolicy") ||
        this.$route.path.startsWith("/sessionexpired")
      );
    },
    paginatedItems() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = this.page * this.itemsPerPage;
      return this.tenantItems.slice(start, end);
    },
    pageCount() {
      return Math.ceil(this.tenantItems.length / this.itemsPerPage);
    },
    processedTreeItems() {
      const CurrentTenant = this.refSelectedTenant.length
        ? this.refSelectedTenant[0]
        : "";
      return this.paginatedItems.map((group) => ({
        ...group,
        disabled: !group.isGroup ? group.id === CurrentTenant : true,
        tenants: Array.isArray(group.tenants)
          ? group.tenants.map((tenant) => ({
              ...tenant,
              disabled: tenant.id === CurrentTenant,
            }))
          : [],
      }));
    },
  },
  methods: {
    ...mapMutations({
      setSwitchTenantId: "setSwitchTenantId",
    }),
    onSearch,
    searchByName,
    getAllGroupNodeIds(items) {
      let ids = [];
      items.forEach((item) => {
        if (item.tenants && item.tenants.length > 0) {
          ids.push(item.id);
        }
      });
      return ids;
    },
    async onTenantChange(activeNodes) {
      const tenant = activeNodes.id;
      const currentTenant = sessionStorage.getItem("tenantId");
      if (tenant !== this.refSelectedTenant[0]) {
        await userAuthService.setActivityLog("logout");
        if (this.$route.path === "/forbidden" || this.$route.path !== "/") {
          this.setSwitchTenantId(tenant);
          sessionStorage.setItem("isTenantSwitch", true);
          this.$router.push({ path: "/" });
        } else {
          sessionStorage.setItem("tenantId", tenant);
          localStorage.setItem("tenantId", tenant);
          const MAX_ATTEMPTS = 10;
          const RETRY_DELAY_MS = 50;

          const waitForTenantChange = async () => {
            for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt++) {
              if (currentTenant !== sessionStorage.getItem("tenantId")) {
                return true;
              }
              await new Promise((resolve) =>
                setTimeout(resolve, RETRY_DELAY_MS)
              );
            }
            return false;
          };

          if (await waitForTenantChange()) {
            await userAuthService.setActivityLog("login");
          }

          this.$router.go();
        }
      }
    },
    openChangeOrderDialog() {
      this.tenantMenu = false;
      this.showTenantOrgDialog = true;
    },
    findNodeById(items, id) {
      for (const item of items) {
        if (item.id === id) return item;
        if (item.tenants?.length) {
          const found = this.findNodeById(item.tenants, id);
          if (found) return found;
        }
      }
      return null;
    },
  },
};

function searchByName(array, searchText) {
  const lowerSearch = searchText.toLowerCase();

  return array.filter((item) => {
    if (item.isGroup && Array.isArray(item.tenants)) {
      return (
        item.name.toLowerCase().includes(lowerSearch) ||
        item.tenants.some((tenant) =>
          tenant.name.toLowerCase().includes(lowerSearch)
        )
      );
    }
    return item.name.toLowerCase().includes(lowerSearch);
  });
}

function onSearch(value) {
  if (value !== "") {
    this.tenantItems = this.searchByName(this.refTenantList, value);
  } else {
    this.tenantItems = this.refTenantList;
  }
}

function isGuid(id) {
  const guidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return guidRegex.test(id);
}
</script>

<style scoped>
.menu-list-item {
  background-color: white !important;
  border-color: white !important;
}
.search-input {
  height: 34px;
  width: 278px !important;
  color: var(--v-neutralGray-base) !important;
  align-items: center !important;
  border-radius: 0 !important;
}
.search-input > .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
}

.search-input /deep/ .v-input__slot {
  min-height: 34px !important;
  /* width: 240px !important; */
}

.search-input /deep/ .v-label {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  color: var(--v-neutralGray-base) !important;
}
.search-input /deep/ input {
  line-height: 16px !important;
}

.theme--light.search-input > .v-input__control > .v-input__slot:before {
  border-color: #cccccc !important;
}
.theme--light.search-input > .v-input__control > .v-input__slot:after {
  border-color: var(--v-neutralGray1-base) !important;
}
.theme--dark.v-input /deep/ input {
  color: var(--v-neutralGray-base) !important;
}
.theme--dark.v-input /deep/ .v-icon {
  color: var(--v-neutralGray-base) !important;
  font-size: 20px !important;
}

::v-deep
  .v-treeview
  .v-treeview-node--disabled
  > .v-treeview-node__root
  > .v-treeview-node__content {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>